/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CampaignResponseFromJSON, CampaignResponseToJSON } from './CampaignResponse';
/**
 * Check if a given object implements the CampaignListResponse interface.
 */
export function instanceOfCampaignListResponse(value) {
    if (!('campaigns' in value) || value['campaigns'] === undefined)
        return false;
    return true;
}
export function CampaignListResponseFromJSON(json) {
    return CampaignListResponseFromJSONTyped(json, false);
}
export function CampaignListResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'campaigns': (json['campaigns'].map(CampaignResponseFromJSON)),
    };
}
export function CampaignListResponseToJSON(json) {
    return CampaignListResponseToJSONTyped(json, false);
}
export function CampaignListResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'campaigns': (value['campaigns'].map(CampaignResponseToJSON)),
    };
}
